module.exports = __webpack_public_path__ + "static/img/国泰君安证券.e044333.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/国泰君安证券.png
// module id = XyYp
// module chunks = 3